import { render } from "./salaryPerson.vue?vue&type=template&id=24f5e8fa&scoped=true"
import script from "./salaryPerson.vue?vue&type=script&lang=js"
export * from "./salaryPerson.vue?vue&type=script&lang=js"

import "./salaryPerson.vue?vue&type=style&index=0&id=24f5e8fa&lang=scss&scoped=true"
import "./salaryPerson.vue?vue&type=style&index=1&id=24f5e8fa&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f5e8fa"]])

export default __exports__